import { useTheme } from "./ThemeProvider";
import { motion } from "motion/react";

export function AmbientBackground() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
      {/* Animated gradient orbs */}
      <motion.div
        animate={{
          x: [0, 100, 0],
          y: [0, -50, 0],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        className={`absolute top-0 right-1/4 w-[600px] h-[600px] rounded-full blur-[150px] ${
          isDark
            ? "bg-gradient-to-br from-primary/10 to-primary-hover/5"
            : "bg-gradient-to-br from-primary/8 to-primary"
        }`}
      />
      
      <motion.div
        animate={{
          x: [0, -80, 0],
          y: [0, 100, 0],
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2
        }}
        className={`absolute bottom-1/4 left-1/3 w-[500px] h-[500px] rounded-full blur-[120px] ${
          isDark 
            ? "bg-gradient-to-tr from-[var(--p-rare)]/8 to-accent" 
            : "bg-gradient-to-tr from-[var(--p-rare)]/6 to-accent"
        }`}
      />

      <motion.div
        animate={{
          x: [0, 60, 0],
          y: [0, -80, 0],
          scale: [1, 1.15, 1],
        }}
        transition={{
          duration: 18,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 5
        }}
        className={`absolute top-1/2 right-1/3 w-[400px] h-[400px] rounded-full blur-[100px] ${
          isDark 
            ? "bg-gradient-to-bl from-[var(--p-legendary)]/5 to-warning" 
            : "bg-gradient-to-bl from-[var(--p-legendary)]/4 to-warning"
        }`}
      />

      {/* Gradient mesh overlay */}
      <div className={`absolute inset-0 opacity-30 ${
        isDark
          ? "bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary via-transparent to-transparent"
          : "bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary via-transparent to-transparent"
      }`} />
    </div>
  );
}
